import { render } from "./FamilyExpress.vue?vue&type=template&id=118da3a2"
import script from "./FamilyExpress.vue?vue&type=script&lang=js"
export * from "./FamilyExpress.vue?vue&type=script&lang=js"

import "./FamilyExpress.vue?vue&type=style&index=0&id=118da3a2&lang=scss"

import exportComponent from "C:\\Users\\caleb\\OneDrive\\Desktop\\apps\\kff_ordering_portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__